module.exports = __webpack_public_path__ + "img/applets3.374f871b.png";